const __CHORD_FAMILIES = [
    'maj',
    'min',
    'aug',
    'dim',
    'sus2',
    'sus4',
    '7',
    'M7',
    'mM7',
    'm7',
    '+M7',
    '+7',
    'ø',
    'o7',
    '7b5',
    'M9',
    '9',
    '7b9',
    'mM9',
    'm9b5',
    'm9',
    '+M9',
    '+9',
    'ø9',
    'øb9',
    'o9',
    'ob9',
    'ø,b9,11',
    'm,b9,11',
    '11',
    '9,#11',
    'M11',
    'mM11',
    'm11',
    '+M11',
    '+11',
    'ø11',
    'o11',
    'M13',
    'M7,#11,13',
    '13',
    'ø,b9,11,b13',
    'm,b9,11,b13',
    'm,9,11,13',
    'mM13',
    'm13',
    '+M13',
    '+13',
    'ø13'
];

function isKnownChordFamily(family: string): boolean {
    return __CHORD_FAMILIES.includes(family);
}

export type ChordStructure = number[];

export {
    isKnownChordFamily
};